import React from "react";
// import "./BlogCard.css";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import { useNavigate } from "react-router-dom";

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (blog.link) {
      // Open external blog link in new tab
      window.open(blog.link, "_blank", "noopener,noreferrer");
    } else {
      // Navigate to internal blog page
      navigate(`/blogs/${blog.id}`);
    }
  };

  return (
    <div className="blog-cards" onClick={handleClick} style={{ cursor: "pointer" }}>
      <div className="card-image-home">
        <img
          src={`${process.env.REACT_APP_BACKEND_URL}${blog.cover_image}`}
          alt={blog.title}
        />
      </div>

      <div className="card-content-home">
        <h3 className="card-title-home">{blog.title}</h3>

        {blog.category && (
          <p className="card-category-home">{blog.category}</p>
        )}

        {blog.created_at && (
          <p className="card-date-home">
            {format(new Date(blog.created_at), "dd MMM yyyy", { locale: enUS })}
          </p>
        )}
      </div>
    </div>
  );
};

export default BlogCard;
